import axios from 'axios';
import { loginreq, req } from './axiosFun';
import { getHttpParams } from '../utils/util';

// 站点列表
export const getRole = (params) => { return req("get", "/admin/roles") };

export const getMenus = (params) => { return req("get", "/admin/get-user-permission") };

//新增
export const addRole = (params) => { return req("get", "/admin/roles/create?"+getHttpParams(params)) };


export const updateRole = (id, params) => { return req("patch", "/admin/roles/"+id+'?'+getHttpParams(params)) };


export const deleteRole = (id) => { return req("delete", "/admin/roles/"+id) };



export const getTreeMenu =() =>{return req("get","/admin/permissions/show")}

export const menuPermSave =(id,params) =>{return req("post","/admin/roles/"+id+"/permissions",params)}

export const getRolePermission = (params) => { return req("get", "/admin/roles/getRolePermission?"+getHttpParams(params)) };







// WEBPACK FOOTER //
// ./src/api/role.js